/**
 * @generated SignedSource<<e7e02e61591980e7647ef588efc86ecc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectsFilter_team$data = {
  readonly portfolio: {
    readonly projects: ReadonlyArray<{
      readonly __typename: string;
      readonly id: string;
      readonly name: string;
      readonly projectTeamShares?: ReadonlyArray<{
        readonly id: string;
      }>;
    }>;
  } | null | undefined;
  readonly projectCategories: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly " $fragmentType": "ProjectsFilter_team";
};
export type ProjectsFilter_team$key = {
  readonly " $data"?: ProjectsFilter_team$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectsFilter_team">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "onlyMyProjects"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "portfolioPath"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectsFilter_team",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectCategory",
      "kind": "LinkedField",
      "name": "projectCategories",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "path",
          "variableName": "portfolioPath"
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "portfolio",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "onlyMyProjects",
              "variableName": "onlyMyProjects"
            }
          ],
          "concreteType": null,
          "kind": "LinkedField",
          "name": "projects",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            },
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProjectTeamShare",
                  "kind": "LinkedField",
                  "name": "projectTeamShares",
                  "plural": true,
                  "selections": [
                    (v0/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "type": "Project",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Team",
  "abstractKey": null
};
})();

(node as any).hash = "7abbf1582fbceb410734f01a4cc55459";

export default node;
